var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 287.27 314.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-1,.cls-2{stroke:#231f20;}.cls-1,.cls-2,.cls-4{stroke-miterlimit:10;stroke-width:0.5px;}.cls-2,.cls-4{fill:none;}.cls-4{stroke:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jaw"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 163.45,
    y: 246.18,
    width: 30.02,
    height: 50.03,
    rx: 13.32,
    transform: "translate(-139.49 205.62) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 167.28,
    y: 250.2,
    width: 22.46,
    height: 41.89,
    rx: 9.97,
    transform: "translate(-139.44 205.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.29,142a8.13,8.13,0,0,0,9.21,0c3.65-2.93,1-9.08,4.5-11.08a5.55,5.55,0,0,1,6.2.93c2,2,.95,5.26-1,14.22-2.81,13.16-3,17.66-2.72,21.66.28,3.73.42,5.59,1.29,7.31,3.32,6.59,12.11,6.32,27.88,9.4,27.87,5.44,35.11,13.05,46.34,15a6.81,6.81,0,0,1,3.76,1.76c3.15,3.15,1.55,9.43,1.1,11.38-4.4,19,3.27,43.48-4.82,47-12.88,5.54-56.69-45.88-67.79-47.52a19.05,19.05,0,0,1-7.81-2.81,18.57,18.57,0,0,1-4.67-4.29c-7.31-9.12-22.26-13.07-26.26-23.81-1.85-5,1.82-4.52,2.8-20.09.4-6.42.65-10.48.08-16.14-1-9.42-3.26-13.87-.77-16.15,1.79-1.66,5.48-1.61,7.69,0C29.53,131.75,26.11,138.76,30.29,142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.18,142a8.12,8.12,0,0,1-9.2,0c-3.66-2.93-1-9.08-4.51-11.08a5.55,5.55,0,0,0-6.2.93c-2,2-1,5.26,1,14.22,2.81,13.16,3,17.66,2.73,21.66-.29,3.73-.43,5.59-1.3,7.31-3.32,6.59-12.11,6.32-27.87,9.4-27.88,5.44-35.12,13.05-46.34,15a6.81,6.81,0,0,0-3.77,1.76c-3.15,3.15-1.55,9.43-1.1,11.38,4.4,19-3.27,43.48,4.83,47,12.87,5.54,56.68-45.88,67.78-47.52a19.05,19.05,0,0,0,7.81-2.81,18.57,18.57,0,0,0,4.67-4.29c7.31-9.12,22.26-13.07,26.26-23.81,1.85-5-1.82-4.52-2.79-20.09-.4-6.42-.66-10.48-.09-16.14,1-9.42,3.26-13.87.78-16.15-1.8-1.66-5.48-1.61-7.69,0C253.94,131.75,257.36,138.76,253.18,142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.82,47.7a18.51,18.51,0,0,0-4.28-3.61c-2.24-1.35-3.3-1.31-5.42-2.26-1.74-.78-6-2.67-7.67-6.76a10.32,10.32,0,0,1,.46-8.8,9.51,9.51,0,0,1,9-4.74,9.28,9.28,0,0,1,6.54,4.06c2.25,3.42,2.25,9,1.58,12.18a6.6,6.6,0,0,0,0,3.39,6.8,6.8,0,0,0,2.48,3.38c5.13,4,18.58,23.41,19.65,25,3.65,5.25,1.91,3.86,10.84,19.73,5.76,10.23,9.78,16.67,11.68,19.85,14.51,24.32,21.2,54.76,21.07,54.78h0c-.75-1.58-19.16-38.19-26.51-51.79-2.52-4.69-6.55-11.85-12.08-20.45-1-1.9-1.94-3.83-3-5.74-1.71-3.08-4.15-7.39-7.41-13.12C125.76,72.75,116.18,55.86,108.82,47.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.54,43.52a17.55,17.55,0,0,1-1,11.11c-.88,2-3.21,7.13-8.53,8.21-4.68.95-8.5-1.91-9.24-2.48A12.1,12.1,0,0,0,93.43,59c4.84-3.12,6.82-10.64,3.89-18.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.87,38.84A17.55,17.55,0,0,0,119.23,43c2.15.1,7.81.36,11.18-3.9,3-3.75,2.14-8.44,2-9.36a12,12,0,0,1-5.11,7.09c-5,2.92-12.57,1.28-17.87-4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.38,31.31a17.55,17.55,0,0,0,11.14-.55c2-.81,7.25-2.94,8.54-8.21,1.12-4.65-1.59-8.57-2.13-9.33a12.06,12.06,0,0,1-1.68,8.58C122,26.52,114.35,28.21,107,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.36,26.33a17.52,17.52,0,0,0,7.72-8c.9-2,3.26-7.11.57-11.83-2.36-4.15-7-5.14-7.94-5.32a12.09,12.09,0,0,1,4.66,7.39c.85,5.7-3.52,12.14-11.05,14.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.56,20.5a17.55,17.55,0,0,0-.24-11.15c-.75-2-2.74-7.33-8-8.76C97.74-.67,93.74,1.93,93,2.46a12,12,0,0,1,8.52,1.92c4.63,3.42,6.11,11.06,2.69,18.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.62,40.52a17.56,17.56,0,0,1-5.08,9.93c-1.56,1.49-5.66,5.4-11,4.4-4.7-.88-7.16-5-7.62-5.77a12.09,12.09,0,0,0,8.5,2c5.67-1.06,10.33-7.29,10.4-15.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.38,39.92A17.62,17.62,0,0,1,81,44.06c-2.15.09-7.82.35-11.18-3.91-3-3.75-2.13-8.45-2-9.36A12,12,0,0,0,73,37.88c5,2.92,12.57,1.29,17.88-4.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.15,37.06a17.57,17.57,0,0,1-10-4.85c-1.53-1.52-5.54-5.53-4.66-10.89.77-4.72,4.8-7.27,5.59-7.76a12.1,12.1,0,0,0-1.79,8.55c1.19,5.64,7.53,10.16,15.52,10"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 84.34,
    y1: 50.02,
    x2: 89.81,
    y2: 51.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 86.77,
    y1: 48.28,
    x2: 87.68,
    y2: 53.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.89,
    y1: 57.85,
    x2: 99.62,
    y2: 59.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.27,
    y1: 56.25,
    x2: 98.16,
    y2: 60.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75.67,
    y1: 38.96,
    x2: 76.82,
    y2: 43.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 77.37,
    y1: 39.24,
    x2: 74.98,
    y2: 43.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 76.17,
    y1: 24.39,
    x2: 71.79,
    y2: 25.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.22,
    y1: 26.91,
    x2: 75.58,
    y2: 23.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.62,
    y1: 5.35,
    x2: 104.68,
    y2: 1.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 101.49,
    y1: 4.38,
    x2: 105.75,
    y2: 2.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 116.37,
    y1: 8.52,
    x2: 120.66,
    y2: 9.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 120.18,
    y1: 7.53,
    x2: 116.47,
    y2: 9.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 125.25,
    y1: 21.8,
    x2: 127.45,
    y2: 25.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 128.31,
    y1: 24.56,
    x2: 124.05,
    y2: 23.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127.26,
    y1: 36.82,
    x2: 129.25,
    y2: 40.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 128.45,
    y1: 36,
    x2: 128.14,
    y2: 41.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.84,63c-10,8.47-19.16,10.84-24.35,11.64C86.81,76,79.41,74.33,65,70.91c-18.21-4.31-18.61-6.83-25.76-6.68C25.45,64.54,12.12,74.2,5.69,85-4.68,102.27-.1,127.35,18.39,145"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.93,74.81A85.4,85.4,0,0,1,95.66,94.93c-26.3,9.53-46.28-11.8-62-1.94C27.53,96.87,21,105.7,19.84,127.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.83,67.78c-2.94,19.31-10.77,29.05-16.5,34.15C90.71,115.83,59.28,123.15,35,122c-2.43-.11-18.69-.93-20.53,4.37a11.81,11.81,0,0,0,.77,7.21A12.88,12.88,0,0,0,17.3,137"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.57,81.24a71.88,71.88,0,0,1-7.75,8.11c-26,23.3-54.91,15.39-84.27,38.65a87.23,87.23,0,0,0-10.47,9.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.88,89c-3.22,3.44-8.32,9-14.3,16.07-22.15,26.18-25.83,37-39.22,45.26-6.62,4.1-17.44,8.71-34.45,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.89,95.93c1.52,30.48-4.39,40.9-10,44.82-13.78,9.63-47.52-4.75-59.23-11-3.46-1.84-14-7.75-21-2.44a12.25,12.25,0,0,0-2.82,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.24,59.64A161.43,161.43,0,0,1,176,42.76c22.15-3.21,71-10.29,95.23,19.88,18.63,23.25,21.85,62.87,3.78,82.53a39,39,0,0,1-10.21,7.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.73,64.57c7.53-3.08,19-6.45,32.06-4.38,22.71,3.59,24.52,19.56,50.46,31.39,27.6,12.58,50,5.65,57.67,19.71,1.23,2.26,6,11,2.24,17.77a12,12,0,0,1-3.23,3.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.57,71.64a63.46,63.46,0,0,1,16-2.25c23.46-.24,29.78,13.16,49,11.58a57.42,57.42,0,0,0,28.93-11.29c6.64-5.46,9.22-10.77,15.05-11.11,8-.45,14.49,8.81,16.7,11.94,14.11,20,6.42,48.48,3.83,56.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.25,78.6A95.6,95.6,0,0,0,165,91.91c16.87,4.56,21.84.77,39.84,4.83,12.26,2.77,31.21,7,39.84,22,5.31,9.21,4.7,19,3.78,24.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.48,86.4c20.44-4.2,31-1,36.86,3.17,8.57,6,5.92,13,15.35,18.45,11.2,6.42,21.36.2,32.25,6.59,6.86,4,9.88,10.64,11.36,15.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.06,165.61a66.87,66.87,0,0,1-7.82-8.27c-5.55-7-7.75-12.65-9.78-16.53-4.74-9.07-11.63-14.21-20.4-20.67-14.77-10.88-16.65-5.22-29.08-15.37-5.44-4.44-11.82-11-21.5-11.36a21.83,21.83,0,0,0-3.91.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 165.3,
    cy: 251.93,
    r: 4.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 159.84,
    y: 252.64,
    width: 3.94,
    height: 5.48,
    transform: "translate(212.44 -42.67) rotate(42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.55,256.09a7.29,7.29,0,0,0,.3.79,5.42,5.42,0,0,0,1,1.57,4.73,4.73,0,0,0,1.2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.24,256.27a35,35,0,0,1,2.75-3,17.1,17.1,0,0,1,3.64-3,13,13,0,0,1,3.94-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.05,259.59a15.92,15.92,0,0,1,2.65-3.26,10.92,10.92,0,0,1,3.5-2.4,9.53,9.53,0,0,1,2.4-.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.89,
    y: 277.99,
    width: 5.35,
    height: 3.72,
    transform: "translate(-148.51 201.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 184.42,
    y: 259.46,
    width: 5.35,
    height: 3.72,
    transform: "translate(-129.98 208.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 235.22,
    y: 271.89,
    width: 30.02,
    height: 50.03,
    rx: 13.32,
    transform: "translate(3.31 596.57) rotate(-100.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 238.99,
    y: 275.89,
    width: 22.46,
    height: 41.89,
    rx: 9.97,
    transform: "translate(3.36 596.47) rotate(-100.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.06,
    y: 308.11,
    width: 5.35,
    height: 3.72,
    transform: "translate(-7.77 613.46) rotate(-100.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 244.34,
    y: 282.33,
    width: 5.35,
    height: 3.72,
    transform: "translate(12.02 578.39) rotate(-100.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 184.74,
    y: 289.68,
    width: 51.44,
    height: 3.95,
    rx: 1.75,
    transform: "translate(125.73 -57.88) rotate(22.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 207.79,
    y: 289.79,
    width: 5.35,
    height: 3.72,
    transform: "translate(-139.07 376.39) rotate(-67.81)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaw);
export default __webpack_public_path__ + "static/media/Jaw.9761e1e55ccfc75531441d24bfc57697.svg";
export { ForwardRef as ReactComponent };